import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Field } from "formik";
import { FormControlLabel, Grid, SearchSelect, DatePicker, ChipGroup, TextField } from "../../../../";
import { CheckboxWithLabel } from "formik-material-ui";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      padding: "20px"
    }
  };
});

var TaskDetailForm = function TaskDetailForm(props) {
  var task = props.task;
  var classes = useStyles();

  var getOptions = function getOptions(field) {
    if (field.options && field.options[0].name !== "") {
      return field.options.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          label: option.name,
          value: option.name
        });
      });
    }
  };

  var fields = task.extraFields && task.extraFields.map(function (field) {
    var fieldType,
        type = "",
        options = [],
        clickable = true,
        multiline = false,
        rows = 1;

    switch (field.type) {
      case "text":
        fieldType = TextField;
        break;

      case "textarea":
        fieldType = TextField;
        multiline = true;
        rows = 4;
        break;

      case "number":
        fieldType = TextField;
        type = "number";
        break;

      case "select":
        fieldType = SearchSelect;
        options = getOptions(field);
        break;

      case "chipGroup":
        fieldType = ChipGroup;
        options = getOptions(field);
        clickable = true;
        break;

      case "checkbox":
        fieldType = CheckboxWithLabel;
        break;

      case "date":
        fieldType = DatePicker;
        break;

      default:
        fieldType = TextField;
        break;
    }

    return field.type === "checkbox" ? /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.service,
      label: field.name // disabled={values.times}
      ,
      control: /*#__PURE__*/React.createElement(Field, {
        name: field.name,
        component: CheckboxWithLabel,
        color: "primary",
        value: field.value,
        disabled: props.task.repeat ? props.task.repeats.find(function (_item) {
          return _item.status !== "done";
        }) ? props.task.repeats.find(function (_item) {
          return _item.status !== "done";
        }).status === "pending" ? true : false : false : props.task.status === "pending"
      })
    }) : /*#__PURE__*/React.createElement(Field, {
      name: field.name,
      type: type || "",
      multiline: multiline || false,
      rows: rows || 0,
      fullWidth: true,
      value: field.value,
      label: field.name === "t" ? "" : field.name,
      component: fieldType,
      className: classes.mr30,
      options: options,
      margin: "normal",
      variant: "outlined",
      clickable: clickable,
      disabled: props.task.repeat ? props.task.repeats.find(function (_item) {
        return _item.status !== "done";
      }) ? props.task.repeats.find(function (_item) {
        return _item.status !== "done";
      }).status === "pending" ? true : false : false : props.task.status === "pending"
    });
  });
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, fields));
}; // TaskDetailForm.propTypes = {
// 	/** Values coming from Formik*/
// 	values: PropTypes.object,
// 	/** Mode to be render. If 'add' content can be added, if 'edit', previous content would be loaded and can be edited, if 'view' no edit option is allowed */
// 	mode: PropTypes.oneOf([ 'edit', 'view', 'add' ])
// };
// TaskDetailForm.defaultProps = {
// 	mode: 'add'
// };


export { TaskDetailForm };